import _slicedToArray from "E:\\Agents\\Agent-04\\_work\\34\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './SocialSharing.css';
import React from 'react';
import { get, getColorByTheme, getGlobalDictionaryTerm, getPageThemeColors } from '../../utils';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import LazyPicture from '../atoms/LazyPicture';
import { ReactComponent as MenuIcon } from '../../resources/icons/m45_menu.svg';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { useLocation } from 'react-router-dom';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { canUseDOM } from 'react-helmet';
var SocialSharing = function SocialSharing(_ref) {
  var fields = _ref.fields,
    params = _ref.params,
    route = _ref.route;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = sitecoreContext.rtl,
    origin = sitecoreContext.origin,
    pageEditing = sitecoreContext.pageEditing;
  var newWindowLabel = getGlobalDictionaryTerm(sitecoreContext, 'newWindowLabel') || "Opens in a new window";
  var _useLocation = useLocation(),
    pathname = _useLocation.pathname;
  var title = get(fields, 'data.item.title.jss');
  var socailLinks = get(fields, 'data.item.socialLinks.values') || [];
  var message = get(fields, 'data.item.likeButtonsTitle.jss.value');
  var BASE_URL = String(process.env.REACT_APP_MEDIA_HOST || '');
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    openMenu = _React$useState2[0],
    setopenMenu = _React$useState2[1];
  var pageTitle = get(route, 'fields.Title');
  var pageIntro = get(route, 'fields.Intro Text');
  var _React$useState3 = React.useState(undefined),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isChina = _React$useState4[0],
    setIsChina = _React$useState4[1];
  var _React$useState5 = React.useState(true),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    isVdsite = _React$useState6[0],
    setIsVdsite = _React$useState6[1];
  React.useEffect(function () {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  var primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  var primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  var selectedPrimaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  var BackgroundColorHex = get(params, 'BackgroundColorHex');
  var ColorHex = get(params, 'ColorHex');
  var ActiveColorHex = get(params, 'ActiveColorHex');
  var variables = BackgroundColorHex ? {
    "--m45-background-color": BackgroundColorHex,
    "--m45-background-active-color": ActiveColorHex,
    "--m45-color": ColorHex
  } : {
    "--m45-background-color": selectedPrimaryColor,
    "--m45-background-active-color": primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active,
    "--m45-color": getColorByTheme(selectedPrimaryColor)
  };
  React.useEffect(function () {
    var urlParams = new URLSearchParams(document.location.search);
    if (isChina === undefined) {
      var isC = Boolean(urlParams.get('isChina') === 'true');
      setIsChina(isC);
    }
  });
  if (!fields) {
    console.warn('Socailshare component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [Socailshare component is empty: please provide data source]");
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
  var viewMoreAnalytics = get(fields, 'data.viewMoreAnalytics');
  var socialAnalytics = get(fields, 'data.socialAnalytics');
  var mainPageTitle = get(fields, 'data.contextItem.title.jss.value');
  var mainPageDescription = get(fields, 'data.contextItem.introText.jss.value');
  var metaDescription = get(fields, 'data.contextItem.metaDescription.jss.value');
  var mainPageName = get(fields, 'data.contextItem.name');
  var mainPageURL = get(fields, 'data.contextItem.url');
  var emailSubject = mainPageName;
  var emailBody = "".concat(mainPageTitle, " ").concat(metaDescription ? metaDescription : mainPageDescription, " ").concat(origin + mainPageURL);
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: "social-sharing row ",
    "data-cy": "social-sharing",
    style: variables
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-1 d-none d-lg-block"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-5"
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "h4",
    className: "h3 accordion-main-heading",
    field: title
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-5 d-none d-lg-block"
  }, /*#__PURE__*/React.createElement("div", {
    className: "social-sharing__row"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "social-sharing__row-ul"
  }, socailLinks.map(function (item, index) {
    var socialIcon = get(item, 'icon.jss.value.src');
    var socialIconTitle = get(item, 'icon.jss.value.alt');
    var socialIconLink = get(item, 'link.jss.value');
    var china = get(item, 'isChina.jss.value');
    var svgIcon = get(item, 'svgIcon.jss.value');
    if (socialIconLink) {
      socialIconLink = socialIconLink.replace('${message}', message);
      socialIconLink = socialIconLink.replace('${link}', origin + pathname);
      socialIconLink = socialIconLink.replace('${email_message}', emailSubject);
      socialIconLink = socialIconLink.replace('${email_link}', emailBody);
      socialIconLink = socialIconLink.replace('${intro}', pageIntro);
      socialIconLink = socialIconLink.replace('${title}', pageTitle);
    }
    var linkTitle = socialIconTitle ? "".concat(socialIconTitle, " | ").concat(newWindowLabel) : newWindowLabel;
    return /*#__PURE__*/React.createElement(React.Fragment, null, !isChina && !china ? /*#__PURE__*/React.createElement("li", {
      key: index,
      className: "social-sharing__li"
    }, /*#__PURE__*/React.createElement("a", {
      className: "social-sharing__a",
      href: socialIconLink,
      target: "_blank",
      rel: "noreferrer noopener",
      title: linkTitle,
      "aria-label": linkTitle,
      "aria-labelledby": linkTitle,
      onClick: function onClick() {
        tealiumClickFunc(tealiumMergeClickData(socialAnalytics, params), "".concat(item.name, " : ").concat(route.name));
      }
    }, svgIcon ? /*#__PURE__*/React.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: svgIcon
      },
      className: "social-sharing__a-icon"
    }) : /*#__PURE__*/React.createElement(LazyPicture, {
      useEmptyPlaceholder: true
    }, /*#__PURE__*/React.createElement("source", {
      media: "(min-width: 768px)",
      srcSet: BASE_URL + socialIcon
    }), /*#__PURE__*/React.createElement("img", {
      className: "social-sharing__icon",
      src: BASE_URL + socialIcon,
      alt: socialIconTitle,
      title: socialIconTitle
    })))) : isChina && china ? /*#__PURE__*/React.createElement("li", {
      key: index,
      className: "social-sharing__li"
    }, /*#__PURE__*/React.createElement("a", {
      className: "social-sharing__a",
      href: socialIconLink != '${wechat}' ? socialIconLink : 'https://www.wechat.com/en/',
      target: "_blank",
      rel: "noreferrer noopener",
      title: linkTitle,
      "aria-label": linkTitle,
      onClick: function onClick() {
        tealiumClickFunc(tealiumMergeClickData(socialAnalytics, params), "".concat(item.name, " : ").concat(route.name));
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "accessibility-hidden-text"
    }, linkTitle), svgIcon ? /*#__PURE__*/React.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: svgIcon
      },
      className: "social-sharing__a-icon"
    }) : /*#__PURE__*/React.createElement(LazyPicture, {
      useEmptyPlaceholder: true
    }, /*#__PURE__*/React.createElement("source", {
      media: "(min-width: 768px)",
      srcSet: BASE_URL + socialIcon
    }), /*#__PURE__*/React.createElement("img", {
      className: "social-sharing__icon",
      src: BASE_URL + socialIcon,
      alt: socialIconTitle,
      title: socialIconTitle
    })), socialIconLink == '${wechat}' ? /*#__PURE__*/React.createElement("div", {
      className: "qrHolder"
    }, /*#__PURE__*/React.createElement("img", {
      src: "https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=".concat(canUseDOM ? window.location.href : 'https://www.visitdubai.com/en')
    })) : null)) : null);
  })))), /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-7 d-lg-none "
  }, /*#__PURE__*/React.createElement("div", {
    className: "social-sharing__row"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "social-sharing__row-ul"
  }, socailLinks.slice(0, 5).map(function (item, index) {
    var socialIcon = get(item, 'icon.jss.value.src');
    var socialIconTitle = get(item, 'icon.jss.value.alt');
    var socialIconLink = get(item, 'link.jss.value');
    var svgIcon = get(item, 'svgIcon.jss.value');
    if (socialIconLink) {
      socialIconLink = socialIconLink.replace('${message}', message);
      socialIconLink = socialIconLink.replace('${link}', origin + pathname);
      socialIconLink = socialIconLink.replace('${email_message}', emailSubject);
      socialIconLink = socialIconLink.replace('${email_link}', emailBody);
    }
    var linkTitle = socialIconTitle ? "".concat(socialIconTitle, " | ").concat(newWindowLabel) : newWindowLabel;
    return /*#__PURE__*/React.createElement("li", {
      key: index,
      className: "social-sharing__li"
    }, /*#__PURE__*/React.createElement("a", {
      className: "social-sharing__a",
      href: socialIconLink,
      target: "_blank",
      rel: "noreferrer noopener",
      title: linkTitle,
      "aria-label": linkTitle,
      onClick: function onClick() {
        tealiumClickFunc(tealiumMergeClickData(socialAnalytics, params), "".concat(item.name, " : ").concat(route.name));
      }
    }, svgIcon ? /*#__PURE__*/React.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: svgIcon
      },
      className: "social-sharing__a-icon"
    }) : /*#__PURE__*/React.createElement(LazyPicture, {
      useEmptyPlaceholder: true
    }, /*#__PURE__*/React.createElement("source", {
      media: "(min-width: 768px)",
      srcSet: BASE_URL + socialIcon
    }), /*#__PURE__*/React.createElement("img", {
      className: "social-sharing__icon",
      src: BASE_URL + socialIcon,
      alt: socialIconTitle,
      title: socialIconTitle
    }))));
  }), socailLinks && socailLinks.length > 5 && /*#__PURE__*/React.createElement("li", {
    onClick: function onClick() {
      setopenMenu(!openMenu);
      tealiumClickFunc(tealiumMergeClickData(viewMoreAnalytics, params));
    },
    className: "menu ".concat(!openMenu ? 'hide-arrow' : '')
  }, /*#__PURE__*/React.createElement(MenuIcon, {
    className: "social-sharing__menu"
  })))), socailLinks && socailLinks.length > 5 && openMenu && /*#__PURE__*/React.createElement("div", {
    className: "social-sharing__column"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "social-sharing__column-ul"
  }, socailLinks.slice(5, 10).map(function (item, index) {
    var socialIcon = get(item, 'icon.jss.value.src');
    var socialIconTitle = get(item, 'icon.jss.value.alt');
    var socialIconLink = get(item, 'link.jss.value');
    var svgIcon = get(item, 'svgIcon.jss.value');
    if (socialIconLink) {
      socialIconLink = socialIconLink.replace('${message}', message);
      socialIconLink = socialIconLink.replace('${link}', origin + pathname);
    }
    var linkTitle = socialIconTitle ? "".concat(socialIconTitle, " | ").concat(newWindowLabel) : newWindowLabel;
    return /*#__PURE__*/React.createElement("li", {
      key: index
    }, /*#__PURE__*/React.createElement("a", {
      className: "social-sharing__a",
      href: socialIconLink,
      target: "_blank",
      rel: "noreferrer noopener",
      title: linkTitle,
      "aria-label": linkTitle
    }, svgIcon ? /*#__PURE__*/React.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: svgIcon
      },
      className: "social-sharing__a-icon"
    }) : /*#__PURE__*/React.createElement(LazyPicture, {
      useEmptyPlaceholder: true
    }, /*#__PURE__*/React.createElement("source", {
      media: "(min-width: 768px)",
      srcSet: BASE_URL + socialIcon
    }), /*#__PURE__*/React.createElement("img", {
      className: "social-sharing__icon",
      src: BASE_URL + socialIcon,
      alt: socialIconTitle,
      title: socialIconTitle
    })), /*#__PURE__*/React.createElement("p", {
      className: "body-small"
    }, socialIconTitle)));
  })))), /*#__PURE__*/React.createElement("div", {
    className: "col-xl-2 col-lg-2 col-md-3 col-2 d-none d-lg-block"
  })));
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl,
    anchorUrlParameter = _ref2.anchorUrlParameter;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: " ".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles, " ").concat(sharingLogicStyles)
  }, children);
};
var commonStyles = "c1vfz4nm";
var sharingLogicStyles = "s14tw71s";
var ltrStyles = "l1fs9w01";
var rtlStyles = "r11lvhy3";
export default SocialSharing;